export default [
    {
    path: "/certificates-data",
    name: "certificates-data",
    permission: "public",
    component: () => import('@/views/certificates/certificates.vue'),
    meta: {
      pageTitle: "Global.Certificates",
      breadcrumb: [{ text: "Global.Certificates", active: true }],
    },
  },
]